import React, { useState, useEffect } from "react";
import "./header.scss";
import { Layout, Dropdown, Typography, Affix, Menu } from "antd";
import { LogoutOutlined, UserOutlined, SettingOutlined, DownOutlined } from "@ant-design/icons";
// import { useSelector } from "react-redux/es/exports";
import { useNavigate } from "react-router-dom";
import klogo from "../../assets/images/fav-ico.png";

// redux
import { bindActionCreators } from "redux";
import * as authActions from "../../redux/actions/auth.actions";
import * as orderManagementActions from "../../redux/actions/orderManagement.actions";
import * as permissionActions from "../../redux/actions/permission.actions";
import { connect } from "react-redux";
import { userhasPermissionHelper, SiteConfigDevPermissionHelper } from "../../utils/Helpers";
import { PERMISSION_CONSTANT } from "../../utils/constants/app";

const { Title } = Typography;
const { Header } = Layout;

const HeaderComponent = ({ authActions, orderManagementActions, permissionActions, permissions, user }) => {
  const [loginAuthCheck, setloginAuthCheck] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // setloginAuthCheck(localStorage.getItem("loginAuthdummy"));
    setloginAuthCheck(localStorage.getItem("user"));
  }, []);
  // const user = useSelector((state) => state.authReducer.user);

  const authchangefalse = async () => {
    await orderManagementActions.resetOrdermanagementRequcerAction();
    await permissionActions.resetPermissionReducerAction();
    await authActions.logoutUserAction().then(() => {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("user_id");
    });
    navigate("/")
  };

  const top = 0.1;
  const menu = () => {
    const item = [
      {
        key: "1",
        label: (
          <a rel="noopener noreferrer" href="#">
            {loginAuthCheck !== undefined ? loginAuthCheck : "User Name"}
          </a>
        ),
        icon: <UserOutlined />,
      },
    ];
    { userhasPermissionHelper(permissions, PERMISSION_CONSTANT.VIEW_SITE_CONFIG_DASHBOARD) &&
      item.push({
        key: "2",
        label: (
          <a
            rel="noopener noreferrer"
            onClick={() => navigate("site/config")}
          >
            Site Config
          </a>
        ),
        icon: <SettingOutlined />,
      });
    }
    { SiteConfigDevPermissionHelper(user?.email) &&
      item.push({
        key: "2-dev",
        label: (
          <a
            rel="noopener noreferrer"
            onClick={() => navigate("site/config-dev")}
          >
            Site Config Dev
          </a>
        ),
        icon: <SettingOutlined />,
      });
    }
    item.push({
      key: "3",
      label: <a onClick={authchangefalse}>Logout</a>,
      icon: <LogoutOutlined />,
    });
    return <Menu
      items={item}
    />
  }

  return (
    <Affix offsetTop={top}>
      <Header className="kmheader">
        <Title level={2} style={{ margin: "0" }}>
          Rocky Back Office
        </Title>
        <Dropdown overlay={menu}>
          <a onClick={(e) => e.preventDefault()}>
            {loginAuthCheck !== undefined ? (
              <span className="user-detail">
                <img src={klogo} alt="logo" /> {loginAuthCheck}
                <DownOutlined />
              </span>
            ) : (
              "User Name"
            )}
          </a>
        </Dropdown>
      </Header>
    </Affix>
  );
};

const mapStateToProps = (state) => {
  return {
    permissions: state.PermissionReducer.permissions,
    user: state.authReducer.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    authActions: bindActionCreators(authActions, dispatch),
    orderManagementActions: bindActionCreators(
      orderManagementActions,
      dispatch
    ),
    permissionActions: bindActionCreators(permissionActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderComponent);
